import React, { Component } from 'react';
import { localize } from 'react-localize-redux';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

export default localize()(
  class TicketStatusIcon extends Component {
    render() {
      const { status, translate, style } = this.props;
      return status === 'new' ? (
        <span style={style} className="ticket_status_label_title small new">
          {translate('maintenanceStatus.new')}
        </span>
      ) : status === 'Reviewed' ? (
        <span style={style} className="ticket_status_label_title small reviewed">
          {translate('maintenanceStatus.reviewed')}
        </span>
      ) : status === 'Scheduled' ? (
        <span style={style} className="ticket_status_label_title small scheduled">
          {translate('maintenanceStatus.scheduled')}
        </span>
      ) : status === 'assigned' ? (
        <span style={style} className="ticket_status_label_title small assigned">
          {translate('maintenanceStatus.assigned')}
        </span>
      ) : status === 'Acknowledged' ? (
        <span style={style} className="ticket_status_label_title small acknowledged">
          {translate('maintenanceStatus.acknowledged')}
        </span>
      ) : status === 'Deferred' ? (
        <span style={style} className="ticket_status_label_title small deferred">
          {translate('maintenanceStatus.deferred')}
        </span>
      ) : status === 'auto_deferred' ? (
        <span style={style} className="ticket_status_label_title small deferred">
          {translate('maintenanceStatus.autoDeferred')}
        </span>
      ) : status === 'Fixing' ? (
        <span style={style} className="ticket_status_label_title small fixing">
          {translate('maintenanceStatus.fixing')}
        </span>
      ) : status === 'Fixed' ? (
        <span style={style} className="ticket_status_label_title small fixed">
          {translate('maintenanceStatus.fixed')}
        </span>
      ) : status === 'Parts Needed' ? (
        <span style={style} className="ticket_status_label_title small partsneeded">
          {translate('maintenanceStatus.partsNeeded')}
        </span>
      ) : status === 'Parts Needed Review' ? (
        <span style={style} className="ticket_status_label_title small partsneeded">
          {translate('maintenanceStatus.partsNeededReview')}
        </span>
      ) : status === 'Closed' ? (
        <span style={style} className="ticket_status_label_title small closed">
          {translate('maintenanceStatus.closed')}
        </span>
      ) : status === 'cancelled' ? (
        <span style={style} className="ticket_status_label_title small cancelled">
          {translate('maintenanceStatus.cancelledNoIssue')}
        </span>
      ) : status === 'cancelled_dup' ? (
        <span style={style} className="ticket_status_label_title small cancelled">
          {translate('maintenanceStatus.cancelledDuplicate')}
        </span>
      ) : status === 'cancelled_no_res' ? (
        <span style={style} className="ticket_status_label_title small cancelled">
          {translate('maintenanceStatus.cancelledNoResponse')}
        </span>
      ) : status === 'Contractor Needed' ? (
        <span style={style} className="ticket_status_label_title contractorneeded">
          {translate('maintenanceStatus.contractorNeeded')}
        </span>
      ) : status === 'Contractor Needed Review' ? (
        <span style={style} className="ticket_status_label_title contractorneeded">
          {translate('maintenanceStatus.contractorNeededReview')}
        </span>
      ) : status === 'vendor_other' ? (
        <span style={style} className="ticket_status_label_title vendorOngoingOther ">
          {translate('maintenanceStatus.vendorOther')}
        </span>
      ) : status === 'vendor_ongoing' ? (
        <span style={style} className="ticket_status_label_title vendorOngoingOther ">
          {translate('maintenanceStatus.vendorOngoing')}
        </span>
      ) : status === 'vendor_cancelled' ? (
        <span style={style} className="ticket_status_label_title vendorCancelled">
          {translate('maintenanceStatus.vendorCancelled')}
        </span>
      ) : status === 'Contact Tenant' ? (
        <span style={style} className="ticket_status_label_title small unhappytenant">
          <TenantResidentVerbiageHelper
            translatedTenant={translate('maintenanceStatus.unhappyTenant')}
            translatedResident={translate('maintenanceStatus.unhappyResident')}
          />
        </span>
      ) : (
        <span style={style} className="ticket_status_label_title small new">
          {translate('maintenanceStatus.new')}
        </span>
      );
    }
  }
);
